module.exports = __webpack_public_path__ + "static/media/FifteenMinuteRule.de04c2d6.mp3";